const useBlockMap = () => {
  const loadIframe = (iframe: HTMLIFrameElement): void => {
    const src = iframe.dataset.src;

    if (!src || iframe.src) {
      return;
    }

    iframe.src = src;
  };

  const initialize = (): void => {
    const iframes = Array.from(document.querySelectorAll<HTMLIFrameElement>('.map-block__iframe'));

    if (!iframes.length) {
      return;
    }

    // If the browser doesn't support IntersectionObserver, load all the iframes immediately.
    if (!('IntersectionObserver' in window)) {
      iframes.forEach(loadIframe);
      return;
    }

    // Load the map only when it is close to the viewport so it cannot steal focus during initial page load.
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        // Load the iframe and stop observing it since we only want to load it once.
        loadIframe(entry.target as HTMLIFrameElement);
        observer.unobserve(entry.target);
      });
    }, {
      rootMargin: '200px 0px',
    });

    // Observe each iframe so we can load it when it is close to the viewport.
    iframes.forEach((iframe) => observer.observe(iframe));
  };

  return {
    initialize,
  };
};

useBlockMap().initialize();
